var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"warning"}},[_c('h1',{directives:[{name:"lang",rawName:"v-lang.header",modifiers:{"header":true}}]}),_vm._v(" "),_c('p',{directives:[{name:"lang",rawName:"v-lang.body",modifiers:{"body":true}}]}),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'Index'}}},[_vm._v("Home")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3439d43f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/not_found.vue
// module id = null
// module chunks = 